/**
 * Footer navigation
 * @module footerItems
 */

import config from './config'
import lang from './lang'

const footerItems = [{
  icon: 'mdi-code-tags',
  url: '/api',
  hint: lang.api
}, {
  icon: 'mdi-facebook',
  url: config.contacts.facebook,
  hint: lang.followUsOnFacebook
}, {
  icon: 'mdi-email',
  url: config.contacts.email,
  hint: lang.emailUs
}]

export default footerItems



// WEBPACK FOOTER //
// ./src/helpers/footer-items.js